/* unplugin-vue-components disabled */import { render } from "./Unfolding3DEditor.vue?vue&type=template&id=0e6a1851&scoped=true"
import script from "./Unfolding3DEditor.vue?vue&type=script&lang=js"
export * from "./Unfolding3DEditor.vue?vue&type=script&lang=js"

import "./Unfolding3DEditor.vue?vue&type=style&index=0&id=0e6a1851&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e6a1851"]])

export default __exports__